export const featureFlags = Object.freeze({
	enable_relation_between_casa_repouso_and_endereco: 'enable_relation_between_casa_repouso_and_endereco'
});
